import * as types from '@/store/types'
export default {
    keyboards: state => {
        return state.keyboards
    },
    getKeyboardById: state => id => {
        return state.keyboards.find(keyboard => keyboard.id === id)
    },
    getKeyboardIndexById: state => id => {
        return state.keyboards.findIndex(keyboard => keyboard.id === id)
    },
    getKeyboardByIndex: state => index => {
        return state.keyboards[index]
    }
}
